import { _, makeGtmCall } from './../utils.js'
import Validate from '../modules/validate.js'
export default class Steps {
    constructor(el) {
        this.el = el
        this.form = _('form', 'element').nodeFrom(this.el)
        this.steps = _('step', 'element').nodesFrom(this.el)
        this.stepTriggers = _('step').nodesFrom(this.el)
        this.stepSections = _('step-section', 'element').nodesFrom(this.el)
        this.previousButton = _('previous', 'element').nodeFrom(this.el)
        this.nextButton = _('next', 'element').nodeFrom(this.el)
        this.submitButton = _('submit', 'element').nodeFrom(this.el)
        this.priceInputs = _('price-input').nodesFrom(this.el)
        this.countOne = false
        this.el.classList.add('main--active')
        this.stepTriggers.map((step) => {
            this.stepTotal = parseFloat(step.dataset.target)
            step.addEventListener('click', this.changeStep)
        })

        this.priceInputs.map((input) => {
            input.addEventListener('input', this.calculatePrice)
        })

        this.calculatePrice()
        this.currentStep = this.el.querySelector(
            '[data-element="step-section"]:not(.u-faded)',
        ).dataset.targetId
        this.form.dataset.gtmStepName = `step ${this.currentStep}`
        makeGtmCall(this.form)
    }

    calculatePrice = () => {
        const itemsTotalEl = _('items-total', 'element').nodeFrom(this.el)
        const priceTotalEl = _('price-total', 'element').nodeFrom(this.el)
        let itemsTotal = 0
        let priceTotal = 0
        let item = 0
        this.priceInputs.map((input) => {
            if (input.type === 'radio' && input.checked) {
                item = 1
            } else if (input.type === 'radio' && !input.checked) {
                item = 0
            } else if (input.value === null || input.value === '') {
                item = 0
            } else {
                item = input.value
            }
            itemsTotal += parseFloat(item)
            priceTotal += item * input.dataset.price
        })

        itemsTotalEl.innerHTML = `${itemsTotal} x membership`
        priceTotalEl.innerHTML = priceTotal.toFixed(2)
        this.toggleSubmitAbility(itemsTotal)
    }

    toggleSubmitAbility = (isNotEmpty) => {
        if (isNotEmpty) {
            this.submitButton.removeAttribute('disabled')
        } else {
            this.submitButton.setAttribute('disabled', '')
        }
    }

    changeStep = (e, triggerTarget) => {
        if (e) {
            triggerTarget = e.currentTarget
        }
        const target = _(triggerTarget.dataset.target, 'target-id').node()
        const targetClass = target.dataset.class
        const currentStep = this.el.querySelector(
            `[data-element="step"][data-target="${triggerTarget.dataset.target}"]`,
        )
        const previousStep = this.el.querySelector(
            `[data-element="step"][data-target="${
                triggerTarget.dataset.target - 1
            }"]`,
        )
        const triggerClass = currentStep.dataset.class

        if (triggerTarget.dataset.validate === 'true') {
            if (!this.validateSection()) {
                return false
            } else {
                previousStep.classList.add('steps__link--done')
            }
        }

        this.steps.map((step) => {
            if (step !== currentStep) {
                step.classList.remove(triggerClass)
            }
        })
        this.stepSections.map((stepSection) => {
            if (stepSection !== target) {
                stepSection.classList.add(targetClass)
            }
        })

        currentStep.classList.add(triggerClass)
        target.classList.remove(targetClass)
        this.form.scrollIntoView()
        this.toggleButtons(triggerTarget.dataset.target)
        if (!this.countOne) {
            this.form.dataset.gtmStepName = `step ${triggerTarget.dataset.target}`
            makeGtmCall(this.form)
            this.countOne = true
            this.form.dataset.gtmStepName = 'submit'
        }
    }

    validateSection = () => {
        const pristine = new Validate(this.form)
        const valid = pristine.validate()
        return valid
    }

    /**
     * @param  {boolean} stepId
     */

    toggleButtons = (stepId) => {
        stepId = parseFloat(stepId)
        if (stepId > 1) {
            this.previousButton.classList.remove('u-hidden')
        } else {
            this.previousButton.classList.add('u-hidden')
        }
        if (stepId === this.stepTotal) {
            this.nextButton.classList.add('u-hidden')
            this.submitButton.classList.remove('u-hidden')
        } else {
            this.nextButton.classList.remove('u-hidden')
            this.submitButton.classList.add('u-hidden')
        }
    }
}
